const env_config = {
  dev: {
    issuer: 'https://travelers-dev.oktapreview.com/oauth2/aus1sbljr5rKNhdhN0h8',
    clientId: '0oa1sbll3g3m7PKnZ0h8',
    redirectUri: typeof window !== 'undefined' && window.location.hostname === 'localhost'
      ? 'http://localhost:3000/login/callback'
      : 'https://xmcontactmgmt-dev.thc.travp.net/login/callback',
  },
  mo: {
    issuer: 'https://travelers-mo.oktapreview.com/oauth2/aus1sw69z7sEAETY70h8',
    clientId: '0oa1sw6f6nzALsnmw0h8',
    redirectUri: 'https://xmcontactmgmt-mo.thc.travp.net/login/callback',
  },
  prod: {
    issuer: 'https://travelers.okta.com/oauth2/aus1tcooc4eLTWbpa0h8',
    clientId: '0oa1tcoo64yi2GdBc0h8',
    redirectUri: 'https://xmcontactmgmt.thc.travp.net/login/callback',
  }
};

const env_config_external = {
  dev: {
    issuer: 'https://access-dev.dev.travelers.com/oauth2/aus1zgnfca4W2UNcy0h8',
    clientId: '0oa1zgnp029UR1RMy0h8',
    redirectUri: 'https://dev.customercontacts.travelers.com/login/callback',
  },
  mo: {
    issuer: 'https://access-mo.travelers.com/oauth2/aus21cmqmsuwjE8kW0h8',
    clientId: '0oa21cmq003X6HQ6y0h8',
    redirectUri: 'https://mo.customercontacts.travelers.com/login/callback',
  },
  prod: {
    issuer: 'https://access-ext.travelers.com/oauth2/aus1w6zu4doy4k0220h8',
    clientId: '0oa1w6zu4dpl7D53Y0h8',
    redirectUri: 'https://customercontacts.travelers.com/login/callback',
  }
};

export function getEnvironment() {
  const host = typeof window !== 'undefined' ? window.location.hostname : undefined;
  if (host === undefined) {
    return 'prod';
  }

  switch (host.toLowerCase()) {
    case 'localhost':
      return 'dev';
    case 'xmcontactmgmt-dev.thc.travp.net':
      return 'dev';
    case 'xmcontactmgmt-mo.thc.travp.net':
      return 'mo';
    case 'xmcontactmgmt.thc.travp.net':
      return 'prod';
    default:
      return 'prod';
  }
}

export function getExternalEnvironment() {
  const host = typeof window !== 'undefined' ? window.location.hostname : undefined;
  if (host === undefined) {
    return 'prod';
  }
  switch (host.toLowerCase()) {
    case 'dev.customercontacts.travelers.com':
      return 'dev';
    case 'mo.customercontacts.travelers.com':
      return 'mo';  
    case 'customercontacts.travelers.com':
      return 'prod';
    default:
      return 'prod';
  }
}

export const oktaAuthConfig = {
  ...env_config[getEnvironment()],
  pkce: true,
  scopes: ['openid', 'profile', 'email', 'groups'],
  tokenManager: {
    autoRenew: true
  }
};

export const externalOktaAuthConfig = {
  ...env_config_external[getExternalEnvironment()],
  pkce: true,
  scopes: ['openid', 'profile', 'email', 'groups'],
  tokenManager: {
    autoRenew: true
  }
};
